export const Organization = {
  '@type': 'Organization',
  name: 'Vodafone',
  logo: {
    '@type': 'ImageObject',
    url: 'https://content.vodafone.com/sites/default/files/2020-10/New_VF_Icon_RGB_RED_rec.jpg',
  },
};
